// 1e+6 = 1000000 (1+6 zeros)
// 100*1e+6 = 100MB
export const slidesSizeLimitBytes = 100 * 1e+6
export const slidesUploadCancel = 'slidesUploadCancel'
